module.exports = __webpack_public_path__ + "static/media/button-center.fbc5f362.png";